import { render } from "./DeviceDisplayShell.vue?vue&type=template&id=bd00652c&scoped=true"
import script from "./DeviceDisplayShell.vue?vue&type=script&lang=js"
export * from "./DeviceDisplayShell.vue?vue&type=script&lang=js"

import "./DeviceDisplayShell.vue?vue&type=style&index=0&id=bd00652c&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/src/Microfrontends/devices/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd00652c"]])

export default __exports__